import { registerWebserverToken } from '../shared/xomics-webserver-client';

const STORAGE_KEY = 'polygen_key';

function getStoredApiKey() {
  return localStorage.getItem(STORAGE_KEY);
}

function setStoredApiKey(key) {
  localStorage.setItem(STORAGE_KEY, key);
}

export async function ensurePolyGenApiKey() {
  let apiKey = getStoredApiKey();

  if (!apiKey) {
    apiKey = crypto.randomUUID();
    setStoredApiKey(apiKey);
  }

  await registerWebserverToken(apiKey);
  return apiKey;
}
